export default {
  state: {
    flairList: [
      { id: 'home', name: 'Frontpage (home)' },
      { id: 'onlinecasino', name: 'Online Casinos' },
      { id: 'new', name: 'New Casinos' },
      { id: 'paynplay', name: 'Pay n Play' },
      { id: 'best', name: 'Best Casinos' },
      { id: 'bonus', name: 'Casino Bonus' },
      { id: 'freespins', name: 'Freespins' },
      { id: 'nodeposit', name: 'No Deposit Bonus' },
      { id: 'wagerfree', name: 'Wagerfree Bonus' },
    ],
  },
  getters: {
    flairList(state) {
      return state.flairList
    },
    flairName: state => id => {
      return state.flairList.find(flair => flair.id === id).name
    },
  },
}
